<script lang="ts" setup>
import DataView from '@/domains/investor/components/DataView/DataView.vue'
import { useReportsDataView } from '@/domains/investor/reports/composables/useReportsDataView'
import InvestorHero from '@/domains/investor/components/Hero/Hero.vue'
import { REPORTS_CATEGORIES_SCOPE } from '@/domains/investor/reports/const/reports-view.const'

const {
  secondCategory,
  months,
  year,
  page,
  itemsPerPage,
  filters,
  clearFilters,
  onSearch,
  searchDraft,
  hasActiveFilters,
  filterLabels,
  reports,
  reportsColumns,
  total,
  filterOptions,
  headerConfig,
  isLoading,
} = await useReportsDataView({
  categoryScope: REPORTS_CATEGORIES_SCOPE,
})

const reportsFilters = computed(() => ({
  models: {
    secondCategory,
    year,
    months,
    searchDraft,
  },
  filters,
  clearFilters,
  showSearch: true,
  showMonths: true,
  showCategory: true,
  showYear: true,
  filterOptions: filterOptions.value,
  hasActiveFilters: hasActiveFilters.value,
  onSearch,
  labels: filterLabels,
}))

definePageMeta({
  layout: 'investor',
})

const { t, locale } = useI18n()

useHead(() => ({
  title: t('pageTitles.investorReports.title'),
  meta: [
    {
      name: 'description',
      content: t('pageTitles.investorReports.meta'),
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: t(`pageTitles.investorReports.canonical.${locale.value}`),
    },
    {
      rel: 'alternate',
      hreflang: 'pl',
      href: t('pageTitles.investorReports.canonical.pl'),
    },
    {
      rel: 'alternate',
      hreflang: 'en',
      href: t('pageTitles.investorReports.canonical.en'),
    },
    {
      rel: 'alternate',
      hreflang: 'x-default',
      href: t('pageTitles.investorReports.canonical.pl'),
    },
  ],
}))
</script>

<template>
   <div>
    <InvestorHero
      :title="$t('investor.reports.title')"
      :lead="$t('investor.reports.lead')"
      image="/images/investor/reports/Raporty.png"
      :first-button="{
        text: $t('investor.reports.firstButton.label'),
        to: $t('investor.reports.firstButton.to'),
      }"
    />

    <DataView
      v-model:page="page"
      :table-items="reports"
      :table-columns="reportsColumns"
      :total="total"
      :table-filters="reportsFilters"
      :header="headerConfig"
      :items-per-page="itemsPerPage"
      :show-pagination="true"
      :is-loading="isLoading"
      :empty-state-message="$t('common.dataView.empty')"
      :section-id="$t('investor.reports.dataView.id')"
    />
   </div>

</template>
